
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[market]/premium",
      function () {
        return require("private-next-pages/[market]/premium.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[market]/premium"])
      });
    }
  